<template>
  <div class="container container-small container-expand bg-light2">

    <div class="content-narrow">
      <AccentHeader
        :header="registerData.header"
        :underline="true"
        :uppercase="false"/>
      <Alert v-if="isRegistered" type="full" :message="registerData.confirmation" />
      <template v-else>

        <p class="text-xs form-addon">
          {{ registerData.addonText }}
        </p>
        <form
          action="#"
          method="post"
          @submit.prevent="validateForm()"
        >
          <fieldset class="form-wrapper">
            <ul class="form-items">
              <li>
                <label for="register-name">
                  {{ registerData.input.name }} <span class="accent">*</span>
                </label>
                <input
                  type="text"
                  name="firstName"
                  id="register-name"
                  v-model="registerFormData['fos_user_registration_form[firstName]']"
                  @focus="clearErrors()"
                  :placeholder="registerData.input.namePlaceholder"
                  required />
              </li>
              <li>
                <label for="register-lastname">
                  {{ registerData.input.lastname }}
                </label>
                <input
                  type="text"
                  name="lastName"
                  id="register-lastname"
                  v-model="registerFormData['fos_user_registration_form[lastName]']"
                  @focus="clearErrors()"
                  :placeholder="registerData.input.lastnamePlaceholder" />
              </li>
              <li>
                <label for="register-email">
                  {{ registerData.input.email }} <span class="accent">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  id="register-email"
                  v-model="registerFormData['fos_user_registration_form[email]']"
                  @focus="clearErrors()"
                  :placeholder="registerData.input.emailPlaceholder"
                  required />
              </li>
              <li>
                <label for="register-pass">
                  {{ registerData.input.password }} <span class="accent">*</span>
                </label>
                <input
                  type="password"
                  name="password"
                  id="register-pass"
                  v-model="registerFormData['fos_user_registration_form[plainPassword][first]']"
                  @focus="clearErrors()"
                  :placeholder="registerData.input.passwordPlaceholder"
                  required />
              </li>
              <li>
                <label for="register-passConfirm">
                  {{ registerData.input.passwordConfirm }} <span class="accent">*</span>
                </label>
                <input
                  type="password"
                  name="passwordConfirm"
                  id="register-passConfirm"
                  v-model="registerFormData['fos_user_registration_form[plainPassword][second]']"
                  @focus="clearErrors()"
                  :placeholder="registerData.input.passwordConfirmPlaceholder"
                  required />
              </li>
              <li>
                <label class="checkbox-item">
                  <input type="checkbox"
                         name="accept"
                         id="register-accept"
                         value="true"
                         v-model="registerFormData['fos_user_registration_form[registerAccept]']"
                         @change="checkCheckbox" />
                  <span class="checkbox-item-label text-xs">
                    {{ contactData.emailNotification.acceptTerms }}
                    <router-link :to="{ name: 'privacy'}">
                      {{ contactData.emailNotification.acceptTermsLink }}
                    </router-link>
                  </span>
                </label>
              </li>
            </ul>
            <button type="submit"
                    class="btn-full"
                    ref="formButton">
              <span class="text-s">{{ registerData.button }}</span>
            </button>
          </fieldset>
        </form>

        <div class="info text-xs" v-if="errors.length">
          <div class="alert alert-error">
            <h5 class="alert-title accent">
              {{ errorData.title }}
            </h5>
            <p class="alert-desc">
              <template v-for="error in errors">
                {{error.msg}}
              </template>
              {{ errorData.tryAgain }}
            </p>
          </div>
        </div>

      </template>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Alert from '@/components/Alert.vue'
import AccentHeader from '@/components/AccentHeader.vue'

export default {
  name: 'registerForm',
  props: ['addon', 'background'],
  components: {
    Alert,
    AccentHeader
  },
  data: function () {
    return {
      registerFormData: {
        'fos_user_registration_form[firstName]': '',
        'fos_user_registration_form[lastName]': '',
        'fos_user_registration_form[email]': '',
        'fos_user_registration_form[plainPassword][first]': '',
        'fos_user_registration_form[plainPassword][second]': '',
        'fos_user_registration_form[registerAccept]': false
      },
      errors: [],
      submitTimer: 0
    }
  },
  methods: {
    ...mapActions([
      'sendRegisterForm'
    ]),
    clearErrors () {
      this.errors = []
    },
    scrollToErrors () {
      let $btn = this.$refs.formButton
      if ($btn) {
        $btn.scrollIntoView()
      }
    },
    validateForm () {
      this.clearErrors()

      if (this.registerFormData['fos_user_registration_form[registerAccept]']) {
        this.sendRegisterForm(this.registerFormData)
      } else {
        this.errors = [{ msg: this.errorData.noApproval }]
        this.scrollToErrors()
      }
    },
    checkCheckbox (event) {
      this.clearErrors()

      if (event.target.checked !== true || !this.registerFormData['fos_user_registration_form[registerAccept]']) {
        this.errors = [{ msg: this.errorData.noApproval }]
        this.scrollToErrors()
      }
    }
  },
  computed: {
    ...mapGetters([
      'isRegistered',
      'getRegisterErrors',
      'registerData',
      'contactData',
      'errorData',
      'apiPath'
    ])
  },
  watch: {
    apiPath (newVal, oldVal) {
      if (oldVal !== newVal) {
        this.clearErrors()
      }
    },
    getRegisterErrors (newVal, oldVal) {
      if (newVal && oldVal !== newVal) {
        if (newVal === 404) {
          this.errors = [{ msg: this.errorData.networkError }]
        } else {
          if (newVal && newVal.length) {
            newVal.forEach((err) => {
              if (!this.errors.some(e => e.msg === err)) {
                this.errors.push({ msg: err })
              }
            })
          } else {
            this.errors = [{ msg: newVal }]
          }
        }
        this.scrollToErrors()
      }
    } // END getRegisterErrors (newVal, oldVal)
  }
}
</script>

<style scoped lang="scss">
.info {
  font-weight: 500;
  margin: $gap-md 0;

  @include screen('sm'){
    margin: $gap-xl 0;
  }

  p {
    margin: $gap-xs 0;
  } // END .info p;

  a {
    text-decoration: none;

    &:hover,&:focus {
      text-decoration: underline;
    }
  } // END .info a;
} // END .info;

</style>
